import type { FetchModelResponse } from '@cian/http-api';

import type { IPopularCitiesForGeoPopupResponseSchema } from '../../../repositories/geo-suggest/entities/entities/PopularCitiesForGeoPopupResponseSchema';
import type { TGetPopularCitiesForGeopopupResponse } from '../../../repositories/geo-suggest/v1/get-popular-cities-for-geopopup';
import { ResponseError, mapResponseErrors } from '../../../utils/errors';

export function assertResponseError(
  response: TGetPopularCitiesForGeopopupResponse,
): asserts response is FetchModelResponse<200, 'json', IPopularCitiesForGeoPopupResponseSchema> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new ResponseError({
    domain: 'shared/services/popularRegions/getPopularRegions#assertResponseError()',
    message: message as string,
    details: mapResponseErrors(errors as unknown[]),
  });
}
